import { Component, Inject, Input, OnInit } from '@angular/core';
import { InstructionService } from '../../services/instruction.service';

@Component({
    selector: 'app-overview-block',
    templateUrl: './overview-block.component.html',
    styleUrls: ['./overview-block.component.scss'],
    standalone: false
})
export class OverviewBlockComponent implements OnInit {
  @Input() part = 1;
  @Input() thumbnail: string;
  @Input() finished = false;
  @Input() name: string;

  partTitle: string;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.partTitle = this.instructionService.getTranslationsForTerm('OVERVIEW_PART');
  }

  getThumbnailPath() {
    return `${this.baseUrl}assets/images/thumbnails/${this.thumbnail}`;
  }
}
